
export enum Path {
  Home = '/landing',

  Home2 = '/home',
  Landing = '/',
  Landlord = '/landing/landlord',
  Lawyer = '/landing/lawyer',
  Agent = '/landing/agent',
  Customer = '/landing/customer',
  Realtor = '/landing/realtor',
  Team = '/team',
  Property = '/property',
  PropertyDetail = '/property/:id',
  AgentProfile = '/agents/:agent_slug',

  About = '/about',
  ContactUs = '/contact',
  Blog = '/blog',
  BlogDetail = '/blog/:id',
  RentPage = '/rent',
  RentDetail = '/rent/:id',
  Listing = '/listing',

  Login = '/login',
  Otp = '/otp',
  Signup = '/signup',
  Buyer = '/signup/buyer',
  ForgotPassword = '/forgot-password',
  ResetPassword = '/reset-password/:token',

  UserDashboard = '/user/dashboard',
  UserDealRoom = '/user/deal-room',
  UserDealRoomDetail = '/user/deal-room/:id',
  UserKyc = '/user/kyc',
  UserProperty = '/user/property',
  UserMessage = '/user/messages',
  UserSetting = '/user/settings',
  UserAddProperty = '/user/property/create',
  LandlordMyPropertyBooking = '/user/property/my-bookings',
  UserAgencyAgreement = '/user/property/agency-agreements',
  UserPropertyDetail = '/user/property/:id',
  UserEditProperty = '/user/property/edit/:id',

  LandlordTenancy = '/user/landlord/tenancies',
  LandlordRentReceipt = '/user/landlord/rent-receipts',
  LandlordRentReminder = '/user/landlord/rent-reminders',
  LandlordRentWallet = '/user/landlord/rent-wallets',
  LandlordNotice = '/user/landlord/notices',
  LandlordJourney = '/user/landlord/journey',
  LandlordEnquiries = '/user/landlord/enquiries',

  LandlordTransactionOffer = '/user/landlord/transaction/offers',
  LandlordTransactionLois = '/user/landlord/transaction/lois',
  LandlordTransactionDealRoom = '/user/landlord/transaction/deal-room',
  LandlordTransactionContracts = '/user/landlord/transaction/contracts',

  BuyerJourney = '/user/buyer/journey',
  BuyerDiscoverProperties = '/user/buyer/discover-properties',
  BuyerPropertyDetail = '/user/buyer/property/:id',
  BuyerBookingsViewings = '/user/buyer/bookings-viewings',
  BuyerInspections = '/user/buyer/inspections',
  BuyerMyEnquiries = '/user/buyer/my-enquiries',
  BuyerDueDiligence = '/user/buyer/due-diligence',
  BuyerMyOffers = '/user/buyer/my-offers',
  BuyerLois = '/user/buyer/lois',
  BuyerTransactionDealRoom = '/user/buyer/deal-rooms',
  BuyerTransactionContracts = '/user/buyer/contracts',


  TenantDiscoverProperties = '/user/tenant/discover-properties',
  TenantPropertyDetail = '/user/tenant/property/:id',
  TenantJourney = '/user/tenant/journey',
  TenantBookingsViewings = '/user/tenant/bookings-viewings',
  TenantMyEnquiries = '/user/tenant/my-enquiries',
  Tenancies = '/user/tenant/tenancies',
  TenantNoticesRenewals = '/user/tenant/notices-renewals',
  TenantAgreements = '/user/tenant/agreements',
  TenantRentReceipts = '/user/tenant/rent-receipts',
  TenantRentWallet = '/user/tenant/rent-wallets',

  AgentsAvailableListings = '/user/agent/available-listings',
  AgentsPropertyDetail = '/user/agent/property/:id',
  AgentJourney = '/user/agent/journey',
  AgentsMyAssignments = '/user/agent/assignments',
  AgentsAgencyAgreements = '/user/agent/agency-agreements',
  AgentsEnquires = '/user/agent/enquiries',
  AgentsBookingInspections = '/user/agent/bookings',
  AgentsDealRooms = '/user/agent/deal-rooms',
  AgentsDealRoomDetails = '/user/agent/deal-rooms/:id',
  AgentsOffers = '/user/agent/offers',
  AgentsCommissions = '/user/agent/commissions',
  AgentsPayout = '/user/agent/payouts',

  //LAWYER

  LawyerEngagement = '/user/lawyer/engagements',
  LawyerJourney = '/user/lawyer/journey',
  LawyerDealRoom = '/user/lawyer/deal-room',
  LawyerDueDiligence = '/user/lawyer/due-diligence',
  LawyerPropertySearch = '/user/lawyer/property-searches',
  LawyerNegotiations = '/user/lawyer/negotiations',
  LawyerContractsOfSales = '/user/lawyer/contracts',
  LawyerTenancyAgreement = '/user/lawyer/tenancy-agreements',
  LawyerDigitalDeeds = '/user/lawyer/deeds',
  LawyerMyDocuments = '/user/lawyer/documents',

  //VALUER

  ValuerAssignedValuation = '/user/valuer/assigned-valuations',
  ValuerJourney = '/user/valuer/journey',
  ValuerValuationReports = '/user/valuer/valuation-reports',
  ValuerDealRoomDocuments = '/user/valuer/deal-room-documents',



  UserManagementDetails = '/user/property/management-property/:id',
  UserNotifications = '/user/notifications',
  UserNotificationDetails = '/user/notifications/:id',


  WaitingList = '/admin/waiting-list',
  AdminLogin = '/admin/login',
  AdminDashboard = '/admin/dashboard',
  AdminProperty = '/admin/properties',
  AdminUsers = '/admin/users',
  AdminSetting = '/admin/settings',
  AdminKycStatus = '/admin/kyc-status',
  AdminPropertyDetail = '/admin/properties/:id',
  AdminDealRoom = '/admin/deal-room',
  AdminDealRoomDetail = '/admin/deal-room/:id',
  AdminBookings = '/admin/bookings',
  AdminNotifications = '/admin/notifications',

  Events = '/events',






}
